module.exports = __webpack_public_path__ + "static/img/icon_cardtype_gallery.11084f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_cardtype_gallery.svg
// module id = Q1fU
// module chunks = 10